<script setup lang="ts">
const props = defineProps<{
  //   name?: string;
  channels: number[]
}>()

const store = useStore()
const router = useRouter()

const allChannels = computed(() =>
  (store.channels || []).map((item) => ({
    value: item.id,
    label: item.name.replace('(Default)', ''),
  })),
)
const tabs = computed(() =>
  (props.channels || [])
    .map((id) => {
      const item = allChannels.value.find((item) => item.value === id)

      if (!item) {
        return null
      }

      return {
        name: item.value,
        label: item.label,
      }
    })
    .filter(Boolean),
)
const channel = useChannel(+tabs.value[0]?.name)
const selectItems = computed(() =>
  tabs.value.map((item) => ({
    value: item.name,
    label: item.label,
  })),
)
const addItems = computed(() =>
  allChannels.value
    .filter(
      (item) =>
        !(props.channels || [])
          .map((id: number | string) => +id)
          .includes(+item.value),
    )
    .map((item) => ({
      id: item.value,
      name: item.label,
    })),
)
const addChannel = async (value: number) => {
  const { isCanceled } = await confirmDialog.reveal()

  if (isCanceled) {
    return
  }

  //   props.context.node.input(value);

  channel.value = value
}
</script>

<template>
  <section
    class="flex items-center bg-gray-100 shadow rounded-lg my-4 py-2 sticky top-0 backdrop-filter backdrop-blur ring-1 ring-black ring-opacity-5 z-20"
    :class="{ 'py-4 flex justify-between': !channels?.length }"
  >
    <template v-if="channels?.length">
      <TabsNavigation
        v-model="channel"
        :tabs="tabs"
        class="hidden md:flex flex-grow overflow-hidden px-2"
      />
    </template>
    <div v-else class="ml-4 md:ml-6">
      <h2 class="text-lg font-medium text-gray-900">Channels</h2>
      <p class="mt-1 text-sm text-gray-500">Add channel from the list</p>
    </div>
    <div class="flex gap-2 mr-4">
      <FormKit
        v-if="channels?.length"
        v-model="channel"
        name="channelId"
        type="multiselect"
        :ignore="true"
        :can-clear="false"
        searchable
        placeholder="Select channel"
        :options="selectItems"
        :classes="{
          outer: 'w-full md:w-[200px] mb-0',
        }"
      >
        <template #option="{ option }">
          <div class="flex justify-between items-center w-full">
            <span>{{ option.label }}</span>
            <Button
              class="place-self-end p-0.5 text-gray-300 group"
              :class="
                option.disabled ? 'hover:bg-green-500' : 'hover:bg-red-500'
              "
              variant="simple"
              size="small"
              @click.prevent.stop="
                option.disabled ? addChannel(option.value) : null
              "
            >
              <div
                v-if="option.disabled"
                class="multiselect-clear-icon i-heroicons-solid-plus group-hover:text-white"
              />
              <div
                v-else
                class="multiselect-clear-icon i-heroicons-solid-minus group-hover:text-white"
              />
            </Button>
          </div>
        </template>
      </FormKit>
      <Combobox :items="addItems" @update:model-value="addChannel($event.id)">
        <Button variant="gray" class="!px-2 text-gray-700 h-full">
          <div class="i-icon-park-outline:plus" />
        </Button>
      </Combobox>
    </div>
  </section>
  <div class="relative z-10">
    <FormKit type="group" name="channelGroup">
      <slot />
    </FormKit>
  </div>
</template>
